import {
  FLUSH_ACCESS_CODE_STATE,
} from 'actiontypes/accessCodes';

export default function flushAccessCodeState() {
  return dispatch => dispatch({ type: FLUSH_ACCESS_CODE_STATE });
}